import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ENavigationErrorType } from './model/enum/navigation-error-type';
import { ENavigationRoute } from './model/enum/navigation-route';
import { CoreData } from './tools/core-data/core-data';
import { detect } from 'detect-browser';

const browser = detect();

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.sass'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent {
  title = 'client';
  PageHeight!: string;
  Overflow!: string;
  
  constructor(
      private route: ActivatedRoute,
      private router: Router,
      private coreData: CoreData) {
          
    }
    
    ngAfterContentInit(): void {
        this.PageHeight = `calc(100% - 70px)`;
        this.Overflow = 'auto';
        
        if (browser && browser.name === 'ie') {
            this.router.navigate([ENavigationRoute.Error, { type: ENavigationErrorType.IE }]);
        }
    }
    
    updateHeight(event: any) {
        this.Overflow = 'hidden';
        setTimeout(() => {
            this.PageHeight = `calc(100% - ${event})`;
            this.Overflow = 'auto';
        }, 0);
    }
}